// extracted by mini-css-extract-plugin
var _1 = "label-ylyRE";
var _2 = "select-NSb0T";
export { _1 as "label", _2 as "select" }
